import {InnerFilters} from 'types';
import {CustomsAuditEventType, CustomsAuditLogParams} from 'types/customs-audit';

export const mapCustomsAuditFilters = (
    filters: InnerFilters,
): Omit<CustomsAuditLogParams, 'paging'> => {
    const text = (key: string) => {
        const item = filters[key];
        const value = item && typeof item === 'object' && 'value' in item ? item.value : item;
        return typeof value === 'string' ? value.trim() || undefined : undefined;
    };
    const [from, to] = (filters.eventTime as [Date | null, Date | null]) || [];
    const eventType = text('eventType') as CustomsAuditEventType | undefined;
    return {
        eventTypes: eventType ? [eventType] : undefined,
        userFullName: text('userFullName'),
        userRole: text('userRole'),
        branchName: text('branches'),
        notificationId: text('notificationId'),
        declarationNumber: text('declarationNumber'),
        sortDesc: filters.sortDesc === undefined ? undefined : filters.sortDesc === 'true',
        from: from
            ? new Date(from.getFullYear(), from.getMonth(), from.getDate()).toISOString()
            : undefined,
        to: to
            ? new Date(to.getFullYear(), to.getMonth(), to.getDate(), 23, 59, 59, 999).toISOString()
            : undefined,
    };
};
